<template>
  <div id="app">
     <div style="padding-top: 30px">

     </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

html,body{

font-family: 'Noto Kufi Arabic', sans-serif;

}

</style>



// WEBPACK FOOTER //
// src/App.vue